module.exports = __webpack_public_path__ + "img/zj.b9cc0fcb.png";